//Main
import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
import store from "./index.js"
vue.use(vuex);


//store
const avancecualitativo = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api`,
    state: {
        Aavancecualitativo: [],
        Aavancecualitativohistoric: []
    }
}).get({
    action: "getavancecualitativo",   
    path: function (obj) {
        return `/avancecualitativo/${obj.idindicador}`;
    }, 
    onSuccess: (state, payload ) => {
        state.Aavancecualitativo = payload.data;
    }
}).get({
    action: "getcualitativohistorico",   
    path: function (obj) {
        return `/avancecualitativo/historial/${obj.idindicador}`;
    }, 
    onSuccess: (state, payload ) => {
        state.Aavancecualitativohistoric = payload.data;
    }
}).put({
    action: "ActualizarCualitativo",
    path: function (obj) {
        return `avancecualitativo/guardaravancecuantitativo`
    },
    onSuccess: (state, payload) => {
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).delete({
    action: "delete_cualitativo",
    path: function (obj) {
        return `avancecualitativo/${obj.idavancecualitativo}`
    },
    onSuccess: (state, payload) => {
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).getStore();

avancecualitativo.getters = {
    gavancecualitativo: state => {
        
        return state.Aavancecualitativo;
    },
    gavancecualitativohistoric: state => {
        
        return state.Aavancecualitativohistoric
    }
}

export default avancecualitativo;